"use strict";

/**
 * Предоставляет инструменты для работы с прикладными константами. 
 *
 * @namespace WebAccess.isbuilder
 * @extends BaseObject
 * @since 5.5.0.5500
 */
(function (global) {
  /**
  * Предоставляет информацию о значений общих констант и констант нашей организации.
  *
  * @namespace WebAccess.isbuilder
  * @since 5.0.0.5500

  * @example
  * var sharedConstValue = WA.isbuilder.constants["CMAgreementStandardRoute"];
  * var sharedConstValue = WA.isbuilder.constants.CMAgreementStandardRoute;
  * var ourFirmConstValue = WA.isbuilder.constants.getOurFirmConstant(38838, "RMArchiveChiefCode");
  */
  var DomainConstants = BaseObject.extend({   
    _ourFirmsConstants: {},

    init: function () {
      $.extend(this, g_SharedPublicConstants);
      this._ourFirmsConstants = g_OurFirmsPublicConstants;
    },

    /**
    * Возврщает значение константы нашей организации.
    *
    * @method WebAccess.isbuilder.constants.getOurFirmConstant
    * @param {integer} firmId ИД нашей организации.
    * @param {string} name Наименование константы.
    * @return {string} Значение константы.
    * @since 5.5.0.5500
    */
    getOurFirmConstant: function (firmId, name) {
      var constants = this._ourFirmsConstants[firmId];
      if (constants)
        return constants[name];
      return null;
    }
  });

  global.constants = new DomainConstants();
})(window.WebAccess.isbuilder);
